import { create } from "zustand";

export type NewAccountInfo = {
  email: string;
  userDisplayName: string;
  ssoProvider: string | undefined;
  domain?: string;
};

type CreateAccountPageState = {
  isSubmittingInfo: boolean;
  isGoogleSsoLoading: boolean;
  isEntraSsoLoading: boolean;
  newAccountInfo: NewAccountInfo;
  showOrgInfo: boolean;
  setIsSubmittingInfo: (value: boolean) => void;
  setIsGoogleSsoLoading: (value: boolean) => void;
  setIsEntraSsoLoading: (value: boolean) => void;
  setNewAccountInfo: (value: Partial<NewAccountInfo>) => void;
  setShowOrgInfo: (value: boolean) => void;
};

export const useCreateAccountPageStore = create<CreateAccountPageState>(
  (set) => ({
    isSubmittingInfo: false,
    isGoogleSsoLoading: false,
    isEntraSsoLoading: false,
    showOrgInfo: false,
    newAccountInfo: {
      email: "",
      userDisplayName: "",
      ssoProvider: undefined,
    },

    setNewAccountInfo: (value) => {
      set((state) => ({
        newAccountInfo: { ...state.newAccountInfo, ...value },
      }));
    },

    setShowOrgInfo: (value) => set({ showOrgInfo: value }),
    setIsSubmittingInfo: (value) => set({ isSubmittingInfo: value }),
    setIsGoogleSsoLoading: (value) => set({ isGoogleSsoLoading: value }),
    setIsEntraSsoLoading: (value) => set({ isEntraSsoLoading: value }),
  })
);
